import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Cookies from 'js-cookie';

import { COOKIE_KEY_CHAT_COMPANY_ID } from '../../const/AppConst';

import CloseView from './pages/CloseView';
import QvCloseView from './pages/qv/QvCloseView';
import DaishinCloseView from './pages/daishin/DaishinCloseView';
import HyundairsCloseView from './pages/hyundairs/HyundairsCloseView';

@observer
class CloseRouter extends Component {
  render() {
    const chatCompID = Cookies.get(COOKIE_KEY_CHAT_COMPANY_ID);

    if (chatCompID === '15') return <QvCloseView {...this.props} />;

    if (chatCompID === '17') return <DaishinCloseView {...this.props} />;

    if (chatCompID === '35') return <HyundairsCloseView {...this.props} />;

    return <CloseView {...this.props} />;
  }
}

export default CloseRouter;
